import amplitude from 'amplitude-js'

export default ({ params }, inject) => {
  amplitude.init(`${process.env.AMPLITUDE_API_KEY}`, null, {
    serverZone: 'EU',
    serverZoneBasedApi: true
  })
  inject('amplitude', amplitude)
}
